var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from 'syf-component-library/ui/atoms';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { StyledBaseButton, StyledPrimaryButton } from '../../../../../styles/buttons';
import { StyledText, StyledTitle } from '../../../../../styles/text';
var CardOption = function (_a) {
    var header = _a.header, body = _a.body, _b = _a.isButton, isButton = _b === void 0 ? false : _b, text = _a.text, onClick = _a.onClick, analyticProps = _a.analyticProps;
    return (_jsx(Card, { children: _jsxs(Inset, __assign({ all: "base" }, { children: [_jsx(StyledTitle, __assign({ size: "medium", weight: "bold" }, { children: header })), _jsx(Stack, { size: "small" }), _jsx(StyledText, __assign({ size: "regular" }, { children: body })), isButton ? (_jsx(Inset, __assign({ top: "medium" }, { children: _jsx(StyledPrimaryButton, __assign({ onClick: onClick }, analyticProps, { children: text })) }))) : (_jsx(StyledBaseButton, __assign({ onClick: onClick, color: "cyanBlue" }, analyticProps, { children: text })))] })) }));
};
export default CardOption;
